<template>

  <div>

    <t-form-list
        :generalErrors="generalErrors"
        :items="items"
        :fields="fields"
        :command="command"
        :user-auth="userAuth"
        :status="status"
        :busy="!pageFormIsLoaded"
        :busy-form="!listFormIsLoaded"
        :busy-list="!listIsLoaded"
        primary-key-column="processFlowLabelPrintRestrictionId"
        :primary-key="form.processFlowLabelPrintRestrictionId"
        :foreign-key-column="foreignKeyColumn"
        :foreign-key="foreignKey"
        @onSubmit="onSubmit"
        @onItemRead="onItemReadDefault"
        @onItemDelete="onItemDeleteDefault">

      <t-input
          v-model="form.processFlowLabelPrintRestrictionId"
          hidden/>

      <b-col cols="12" class="mb-2">

        <b-row>

          <b-col xl="9">

            <b-row>

              <t-input
                  cols="6"
                  v-model="form.labelId"
                  :options="labelOptions"
                  :add-error="error.labelId"
                  label="Etiqueta"
                  select
                  required
                  ref="firstInput"/>

              <t-input
                  cols="6"
                  v-model="form.firstPrintByEvent"
                  :options="FirstPrintByEventType.list"
                  label="Condição para Liberação da 1ª Impressão"
                  radio
                  required/>

            </b-row>

            <b-row>

              <t-input
                  cols="6"
                  highlight
                  v-if="form.firstPrintByEvent === FirstPrintByEventType.type.AFTER_STEP_COMPLETION"
                  :required="form.firstPrintByEvent === FirstPrintByEventType.type.AFTER_STEP_COMPLETION"
                  v-model="form.processFlowStepId"
                  :options="stepOptions"
                  label="Etapa do Fluxo de Processo"
                  select/>

              <t-input
                  cols="6"
                  v-model="form.note"
                  label="Observações"
                  textarea/>

            </b-row>

          </b-col>


          <b-col xl="3" class="button-form-inline">

            <t-button
                :sending="status === 'sending'"
                tabindex="3"
                :text="onButtonSubmitText(command)"
                no-icon
                submit/>

            <b-link
                class="ml-2 text-focus"
                v-if="command === 'update'"
                @click="cancelUpdatedList()">
              {{ t('go-back') }}
            </b-link>

          </b-col>

        </b-row>

      </b-col>

      <template #item(firstPrintByEvent)="{item}">

        <div v-if="item.firstPrintByEvent === FirstPrintByEventType.type.AFTER_STEP_COMPLETION">
          Após conclusão de etapa<br /><strong>{{item.processFlowStep}}</strong>
        </div>

        <div v-if="item.firstPrintByEvent === FirstPrintByEventType.type.AFTER_EXPEDITION_INSERTED">
          Após inclusão em uma <strong>Expedição</strong>
        </div>


      </template>

    </t-form-list>

  </div>


</template>

<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import FirstPrintByEventType from "@/model/types/modules/general/FirstPrintByEventType";
import ProcessFlowStepService from "@/services/modules/production/ProcessFlowStep.service";
import LabelService from "@/services/modules/general/Label.service";


export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'ProcessFlowLabelPrintRestriction',
  data() {
    return {
      FirstPrintByEventType,
      path: "production/process-flow-label-print-restriction", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "processFlowId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "processFlowLabelPrintRestrictionId", keyDelete: "processFlowLabelPrintRestrictionId"},
        {key: "label", label: "Etiqueta Layout", cols: "4"},
        {key: "firstPrintByEvent", label: "Imprimir Quando", cols: "3"},
      ],
      form: {
        processFlowId: this.foreignKey,
        processFlowLabelPrintRestrictionId: 0,
        firstPrintByEvent: 0,
        labelId: 0,
        processFlowStepId: 0,
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        labelId:"",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      stepOptions: [],
      labelOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      this.form.firstPrintByEvent = this.FirstPrintByEventType.type.AFTER_STEP_COMPLETION


      this.focusByRef('firstInput')

    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await ProcessFlowStepService.selectList(this.foreignKey, false)
          .then(list => this.stepOptions = list)

      await LabelService.selectList()
          .then(list => this.labelOptions = list)

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.processFlowLabelPrintRestrictionId)


    },

    mountedList() {

      this.focusByRef('firstInput')

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
